// Секция полей левой колонки карточки — группа строк под мелким заголовком,
// как «О сделке» / «Клиент» в Bitrix. Сама ничего не знает про данные: получает
// готовые описания полей и один обработчик сохранения на всех (право писать и
// проводку в API решает страница).
import type { ReactNode } from 'react'

import { FieldRow } from './FieldRow'
import type { CardField } from './FieldRow'
import './card.css'

interface Props {
  title: string
  fields: CardField[]
  onSave?: (code: string, value: unknown) => Promise<void> | void
  /** Дополнение под строками (оговорка о правах, подсказка). */
  children?: ReactNode
}

export function FieldSection({ title, fields, onSave, children }: Props) {
  return (
    <section className="fieldsec">
      <div className="fieldsec-title">{title}</div>
      {fields.map((f) => <FieldRow key={f.code} field={f} onSave={onSave} />)}
      {children}
    </section>
  )
}
